import {ButtonVariant} from "@/components/button/Button.types.ts";
import {Divider} from "@/components/divider/Divider.tsx";
import {DropdownHeader} from "@/components/dropdown/subComponents/DropdownHeader/DropdownHeader.tsx";
import {DropdownItem} from "@/components/dropdown/subComponents/DropdownItem/DropdownItem.tsx";
import {DropdownButton} from "@/components/dropdownButton/DropdownButton.tsx";
import {IconButton} from "@/components/iconButton/IconButton.tsx";
import {IconButtonSizeType} from "@/components/iconButton/IconButton.types.ts";
import classnames from "classnames";
import {FaCheck} from "react-icons/fa6";
import {FiRefreshCw} from "react-icons/fi";
import styles from "./AutoRefreshButton.module.scss";

const REFRESH_VALUES: {seconds: number | undefined; label: string}[] = [
  {seconds: undefined, label: "Off"},
  {seconds: 60, label: "2 min"},
  {seconds: 60 * 5, label: "5 min"},
  {seconds: 60 * 10, label: "10 min"},
  {seconds: 60 * 15, label: "15 min"},
  {seconds: 60 * 30, label: "30 min"},
  {seconds: 60 * 60, label: "60 min"},
];

interface AutoRefreshButtonProps {
  className?: string;
  seconds?: number;
  setSeconds: (seconds?: number) => void;
  doRefresh?: () => void;
  size?: IconButtonSizeType;
  variant?: ButtonVariant;
  progressPercent?: number;
  showActiveState?: boolean;
}

export const AutoRefreshButton = ({
  className,
  seconds,
  setSeconds,
  doRefresh,
  size,
  variant = "secondary",
  progressPercent,
  showActiveState = false,
}: AutoRefreshButtonProps) => {
  const isActive = seconds != null && seconds > 0;

  return (
    <div
      className={classnames(
        styles.wrapper,
        {[styles.active]: showActiveState && isActive, [styles.inheritColor]: variant === "ghostUnderline"},
        className
      )}
    >
      <DropdownButton as={IconButton} icon={FiRefreshCw} size={size} variant={variant}>
        <DropdownHeader>Auto-Refresh</DropdownHeader>
        <Divider />
        {REFRESH_VALUES.map((v) => (
          <DropdownItem key={v.label} onClick={() => setSeconds(v.seconds)}>
            {v.seconds === seconds && <FaCheck className="me-2" />}
            <span
              className={classnames({
                "ms-4": v.seconds !== seconds,
              })}
            >
              {v.label}
            </span>
          </DropdownItem>
        ))}
        {doRefresh && (
          <>
            <Divider />
            <DropdownItem onClick={doRefresh}>
              <span className="ms-4">Refresh Now</span>
            </DropdownItem>
          </>
        )}
      </DropdownButton>
      {isActive && progressPercent != null && (
        <div className={styles.progressBar} style={{width: `${progressPercent}%`}} />
      )}
    </div>
  );
};
